<div class="w-100 d-flex flex-column align-items-center justify-content-center">
  <div>
    <img src="../../../../assets/img/logo-enexdirecto.png" class="img-fluid mt-4 mb-5" />
  </div>
<h2 class="text-center mb-4">Recuperar tu cuenta</h2>
</div>
  <div class="recovery-container px-4 px-md-3 h-100 mb-5">

  <form [formGroup]="formRecovery" (submit)="recover()">

    <div class="form-group">
      <div class="custom-input-group mb-3">
        <div class="input-group-prepend">
          <span class="icon-RUT-empresa---cliente"></span>
        </div>
        <input formControlName="rutEmpresa" id="rutEmpresa" type="text" class="form-control" placeholder="RUT empresa / cliente" aria-label="RUT empresa / cliente"
        [class.border-danger]="f.rutEmpresa.errors && (f.rutEmpresa.dirty || f.rutEmpresa.touched)">
        <div class="form-message">
          <small>*Obligatorio</small>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="custom-input-group mb-3">
        <div class="input-group-prepend">
          <span class="icon-Rut-usuario"></span>
        </div>
        <input type="text" formControlName="rutCliente" id="rutCliente" class="form-control" placeholder="RUT usuario" aria-label="RUT usuario"
        [class.border-danger]="f.rutCliente.errors && (f.rutCliente.dirty || f.rutCliente.touched)">
        <div class="form-message">
          <small>*Obligatorio</small>
        </div>
      </div>
    </div>
    <div class="form-group mb-4">
      <div class="custom-input-group mb-3">
        <div class="input-group-prepend">
          <span class="icon-Correo"></span>
        </div>
        <input type="text"  formControlName="email" id="email" class="form-control" placeholder="Correo electrónico" aria-label="Correo electrónico"
        [class.border-danger]="f.email.errors && (f.email.dirty || f.email.touched)">
        <div class="form-message">
          <small>*Obligatorio</small>
        </div>
      </div>
    </div>

    <div class="form-group">
      <div class="custom-input-group mb-3">
        <re-captcha
          (resolved)="resolved($event)"
          [siteKey]="googleCaptchaSiteKey"
          formControlName="recaptchaReactive"
        ></re-captcha>
      </div>
    </div>

    <div class="col-12 col-md-10 mx-auto d-flex flex-column justify-content-center">
      <button type="submit" class="btn btn-success btn-block mb-4" [disabled]="formRecovery.invalid">
        <span *ngIf="!loader.recover;else tmpLoader">Recuperar</span>
      </button>
    </div>
  </form>

  <div class="alert alert-danger alert-dismissible fade show mt-3" *ngIf="error.status" role="alert">
    {{ error.descripcion}}
  </div>

  <div class="row no-gutters d-flex justify-content-center h-100">

    <div style="align-self: flex-end;">
      <img src="../../../../assets/img/logo-enex.svg" class="img-fluid logo-enex mx-auto mb-3" />
    </div>
  </div>
</div>


<ng-template #tmpLoader>
  <span class="spinner-border text-white" role="status">
    <span class="sr-only">Loading...</span>
  </span>
</ng-template>
